import axios from "axios";
import { getConfigHeader, refrech, URL_LOG } from "./config";

const findAll = async () => {
  return refrech()
    .then(() => axios.get(URL_LOG, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

export { findAll };
